'use client'

import { useReportWebVitals } from 'next/web-vitals'
import { capturePostHogEvent } from '@/utils/posthogClient'

export default function WebVitalsReporter() {
  useReportWebVitals((metric) => {
    capturePostHogEvent('web_vital', {
      metric: metric.name,
      value: Math.round(metric.name === 'CLS' ? metric.value * 1000 : metric.value),
      rating: metric.rating,
      path: typeof window === 'undefined' ? '' : window.location.pathname,
    })
  })

  return null
}
